import type { ContractingFieldHistoryEntry } from '~/types/services/contracting';

import type { FieldHistoryEntry } from './types';

const RECORD_EVENT_LABELS: Record<Exclude<ContractingFieldHistoryEntry['action'], 'UPDATE'>, string> = {
  CREATE: 'Record created',
  LOCK: 'Record locked',
  UNLOCK: 'Record unlocked',
};

// The opportunity, account or case is the page's own record; child rows name which record changed.
const PAGE_RECORD_TYPES: ReadonlyArray<ContractingFieldHistoryEntry['entity_type']> = [
  'opportunity',
  'account',
  'case',
];

const UNKNOWN_USER = 'Unknown user';

function fieldLabel(entry: ContractingFieldHistoryEntry): string {
  const label =
    entry.action === 'UPDATE' ? (entry.field_label ?? entry.field ?? '') : RECORD_EVENT_LABELS[entry.action];
  if (PAGE_RECORD_TYPES.includes(entry.entity_type) || !entry.entity.name) {
    return label;
  }
  return `${entry.entity.name} · ${label}`;
}

export function toFieldHistoryEntries(entries: ReadonlyArray<ContractingFieldHistoryEntry>): Array<FieldHistoryEntry> {
  return entries.map((entry) => ({
    id: entry.external_refs.salesforce,
    changedAt: entry.changed_at,
    field: fieldLabel(entry),
    user: entry.changed_by?.name ?? UNKNOWN_USER,
    previousValue: entry.old_value,
    newValue: entry.new_value,
  }));
}
